import config from '../../config';
import authHeader from '../../helpers/authHeader';
import { apiClient, handleResponse } from './axios';

async function getSurvey(id, semester, companyId) {
  if (id == null || semester == null || companyId == null) {
    return null;
  }
  const headers = { Accept: 'application/json' };
  const token = authHeader();
  if (typeof token === 'string') {
    headers.Authorization = token;
  }
  const path = `/survey/single/${encodeURIComponent(id)}/Students/${encodeURIComponent(String(semester))}/${encodeURIComponent(companyId)}`;
  try {
    const res = await fetch(`${config.API_URL}${path}`, {
      headers,
      credentials: 'include',
    });
    if (res.status !== 200) {
      return null;
    }
    return res.json();
  } catch {
    return null;
  }
}

async function updateSurvey(id, body) {
  try {
    const response = await apiClient.put(`/survey/${id}`, body);
    const semester = await handleResponse(response);
    return semester;
  } catch (error) {
    return error.response;
  }
}
const surveysServices = {
  updateSurvey,
  getSurvey,
};

export default surveysServices;
